import script from "./meeting-host-settings.vue?vue&type=script&setup=true&lang=ts"
export * from "./meeting-host-settings.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__